import axios from 'axios';

// Get API endpoint from environment variable, with fallback for development.
// In dev the browser always calls the same-origin relative `/api`; setupProxy
// forwards it server-side to the local API (or the beta API when
// REACT_APP_USE_BETA_API is set). Same-origin means the site loads from any host
// — localhost or a LAN address like http://192.168.0.248:3000 — with no CORS.
export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.videoplussensors.com/api'
    : '/api');

export const axiosInstance = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status !== 401 || originalRequest._retry || originalRequest.url === '/auth/refresh') {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => axiosInstance(originalRequest));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      await axiosInstance.post('/auth/refresh');
      processQueue(null);
      return axiosInstance(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError);
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export const convertStringJsonToObject = (stringJson) => JSON.parse(stringJson.toString());
